<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='btns.import' prefixIcon='icon hero-icon hero-icon-advanced-search-detailed' :tooltipText='$t("Track.refreshTask")' :click='buttonClk' operate='refrush'></e-item>
        <e-item v-if='btns.export' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("System.generate")' :click='buttonClk' operate='export'></e-item>
        <e-item v-if='btns.export' prefixIcon='icon hero-icon hero-icon-batch-export' :tooltipText='$t("System.generateAll")' :click='buttonClk' operate='exportAll'></e-item>
        <!-- <e-item v-if='btns.import' prefixIcon='icon hero-icon hero-icon-excel-import' :tooltipText='$t("System.batchImport")' :click='buttonClk' operate='import'></e-item> -->
        <e-item v-if='btns.export' prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("System.batchInitNECfg")' :click='buttonClk' operate='import'></e-item>
      </e-items>
    </ejs-toolbar>
  <div v-if='btns.keywordsInput' class='h-inputBox' style="width:400px;">
    <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("System.inputNodeIdSection")' @keydown.native='updateKeywords'></ejs-textbox>
  </div>
  <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
    <template v-slot:dialog-content>
      <AddDialog ref='addObj'></AddDialog>
    </template>
  </CustomDialog>
  </div>
</template>

<script>
import bus from '../bus.js';
import BasicLayout from '../../../layouts/BasicLayout';
import AddDialog from '../../../components/system/ConfigInEx/addDialog';
import CustomDialog from '../../../components/common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import socketInstance from '../../../plugins/stompSock';

let checkData = [];
const keyMap = new Map();
let fileName ="";
export default {
  name: 'ConfigTableMenu',
  components: {
    BasicLayout,
    AddDialog,
    CustomDialog
  },
  data() {
    return {
      btns: {
        import: true,
        export: true,
        upload:true,
        download: true,
        keywordsInput: true,
        restore: true
      },
      queryConditions: {
        keywords: '', // 模糊查询关键字
      },
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('System.analyiseButton') } },
          ],
          title: this.$t('System.uploadText')
        },
      },
      recoverylDialog: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        element: {
          refName: "recoveryResult",
          isClose: true,
          buttonGroup: [
            { click: this.recoverylDialogHide, buttonModel: { content: this.$t('System.confirm') }, isPrimary: true }
          ],
          title: this.$t('System.recoveryResult')
        }
      },
      recoveryResult: '',
      websocketSetting: [
        { topic: '/user/#/BatchInitNECfgServer', clientId: 'export', callback: this.websocketCallback }
      ]
    };
  },

  mounted() {
    fileName ="";
    console.log("=====fileName===",fileName);
    bus.$on('selectNeData', (neNode) => {
      checkData = neNode;
    });

    bus.$on('fileName', (neNode) => {
      console.log("=====neNode===",neNode);
      fileName = neNode;
    });
    this.websocketInit();
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args.item.operate);
    },
    exportData(params){
      this.$loading.showLoadding(this.$t('Software.progressing'));
      axios({
        method: 'post',
        url: '/lte/ems/config/mml/exportMinimalNeConfig',
        data:params,
      }).then(response => {
        this.$loading.hideLoadding();
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          EventBus.$emit('toast', {type: 'warn', content:this.$t('System.exportSuccess') });
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      })
    },
    updateKeywords(clickEvent) {
      if (clickEvent.keyCode === 13) {
        this.$emit('keywords', this.queryConditions.keywords.trim());
      }
    },
    addDialog() {
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
    },
    dialogHide() {
      if(fileName ==""||fileName == undefined){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return;
      }
      let index = fileName.lastIndexOf(".");
      let fileType = fileName.substring(index+1).toLocaleLowerCase();

      if(fileType !='xlsx'){
        this.eventEmit('warning', this.$t('System.fileTypeError'));
        return;
      }
    
      if(this.uploadProps.status == 1){
          this.$layer.confirm({ 
          msg: this.$t('MML.neCfgRestoreConfirmTip'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {                                      
                  this.$loading.showLoadding(this.$t('Software.progressing'));
                  const url = '/lte/ems/config/mml/batchInitNECfg';
                  const param = {
                    fileName: fileName
                  };
                  this.$axios.post(url, param).then(response => {
                    this.$loading.hideLoadding();
                    fileName = "";
                    if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
                      let checkResult = response.data.resultVal;
                      if(checkResult){
                        EventBus.$emit('toast', {type: 'warn', content:this.$t('System.batchInitNECfgCheckSuccess') });
                      }else{
                        EventBus.$emit('toast', {type: 'warn', content:this.$t('System.batchInitNECfgCheckFail') });
                      }
                    } else {
                      EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
                    }
                  });
                  this.$refs.upload.clear();
                  this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('MCS.cancle')
          }
      });

      }else{
          this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                this.$refs.upload.clear();
                this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    },
    websocketInit() {
      // this.websocketSetting[0].clientId = 1? 1 : '';
      if (socketInstance.stompClient == null) {
        socketInstance.init(this.websocketSetting);
        console.log("=============>>>>>","socketInstance");
      } else {
        socketInstance.dynamicSubscribe(this.websocketSetting[0].topic, this.websocketSetting[0].clientId, this.websocketCallback);
          console.log("=============>>>>>","dynamicSubscribe");
      }
    },
    websocketCallback(msg) {
      const data = JSON.parse(msg.body);
      console.log("msg=======websocketCallback=============",data);
      if(data.path =='error'){
          EventBus.$emit('toast', {type: 'error', content:this.$t('System.exportFail') });
      }else{
        if(keyMap.has(data.fileName)){
          console.log("this file has been already downloaded")
        }else{
          keyMap.set(data.fileName,1);
          axios({
            method: 'post',
            url: '/lte/ems/config/mml/downLoadConfigZip',
            data:data,
            // 二进制流文件，一定要设置成blob，默认是json
            responseType: 'blob'
          }).then(response => {
            const link = document.createElement('a');
            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
            let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", regFileNames);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        }
      }
    }
  },
  beforeDestroy() {
    bus.$off('selectNeData');
    bus.$off('fileName');
  }
};
</script>
